import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: translations.en });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rc_lang") || "en");

  useEffect(() => {
    localStorage.setItem("rc_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.en }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
